import { Navigate } from "react-router-dom";
import { PageIntro } from "@/components/site/PageIntro";
import { Reveal } from "@/components/site/Reveal";
import { useSeo } from "@/components/site/Seo";
import { legalContent } from "@/pages/legalContent";

export default function LegalPage({ slug }) {
  const data = legalContent[slug];
  useSeo({
    title: data ? data.title : "Legal",
    description: data ? data.desc : "Velora Intelligence legal information.",
    path: `/${slug}`,
  });

  if (!data) return <Navigate to="/" replace />;

  return (
    <main data-testid={`legal-page-${slug}`}>
      <PageIntro label={data.label} title={data.title} desc={data.desc}>
        <p className="mt-4 text-xs italic text-white/40">{data.updated}</p>
      </PageIntro>

      <section className="relative z-10 mx-auto max-w-3xl px-4 py-16 sm:px-6 md:py-24">
        <div className="space-y-10">
          {data.sections.map((s, i) => (
            <Reveal key={i} delay={i % 3}>
              <div>
                <h2 className="font-display text-xl font-bold text-white md:text-2xl">
                  {s.h}
                </h2>
                <div className="mt-4 space-y-3">
                  {s.p.map((p, j) => (
                    <p key={j} className="text-sm leading-relaxed text-white/60 md:text-base">
                      {p}
                    </p>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
